import clsx from "clsx";
import {
  AnchorHTMLAttributes,
  ButtonHTMLAttributes,
  FunctionComponent,
  PropsWithChildren,
} from "react";

import styles from "./Button.module.css";

// @todo only add `rel` and `target` for external links
export const Button: FunctionComponent<
  PropsWithChildren<
    { wide?: boolean } & (
      | (AnchorHTMLAttributes<HTMLAnchorElement> & { href: string })
      | ButtonHTMLAttributes<HTMLButtonElement>
    )
  >
> = ({ children, className, wide = false, ...props }) =>
  "href" in props ? (
    <a
      {...props}
      className={clsx(className, styles.root, { [styles.wide]: wide })}
      rel="noreferrer"
      target="_blank">
      <span className={styles.background} />
      {children}
    </a>
  ) : (
    <button
      {...props}
      className={clsx(className, styles.root, { [styles.wide]: wide })}
      type={props.type ?? "button"}>
      <span className={styles.background} />
      {children}
    </button>
  );
